import { cn } from '~/lib/cn';

export interface CommentProps {
  className?: string;
  value?: string;
  maxLength?: number;
}

function Comment(props: CommentProps): JSX.Element {
  const maxLength = props.maxLength ?? 15;
  const comment = props.value ?? '';

  if (comment.length > maxLength) {
    return (
      <span className={cn('', props.className)} title={props.value}>
        {comment.slice(0, maxLength)}...
      </span>
    );
  }

  return <span className={cn('', props.className)}>{comment || '--'}</span>;
}

Comment.displayName = 'Comment';

export { Comment };
